// Exécute une tâche au plus une fois par intervalle. Les demandes reçues entre-temps ne sont pas perdues :
// elles se regroupent en une seule exécution à la fin de l'intervalle (ou à la fin de la tâche en cours).
export function createThrottledRunner(task, minIntervalMs) {
    let lastStartedAt = -Infinity
    let timer = null
    let running = false
    let pending = false

    const schedule = () => {
        if (timer) {
            return
        }

        const wait = Math.max(0, lastStartedAt + minIntervalMs - Date.now())
        timer = setTimeout(run, wait)
    }

    const run = async () => {
        timer = null
        running = true
        pending = false
        lastStartedAt = Date.now()

        try {
            await task()
        } catch (error) {
            console.error("Rechargement impossible", error)
        } finally {
            running = false
            if (pending) {
                schedule()
            }
        }
    }

    const request = () => {
        if (running) {
            pending = true
            return
        }

        schedule()
    }

    const cancel = () => {
        clearTimeout(timer)
        timer = null
        pending = false
    }

    return {request, cancel}
}
